import { render } from "./sbRightAd.vue?vue&type=template&id=3756b76b&scoped=true"
import script from "./sbRightAd.vue?vue&type=script&lang=js"
export * from "./sbRightAd.vue?vue&type=script&lang=js"

import "./sbRightAd.vue?vue&type=style&index=0&id=3756b76b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3756b76b"]])

export default __exports__